<div class="row g-4">
    <div class="col-12 col-lg-4">
        <div class="ob-dash-week-card">
            <p class="ob-dash-week-label">Assignments</p>
            <p class="ob-dash-week-sublabel">This Week</p>
            <div class="ob-dash-week-circle obrame-dashboard-info obrame-dashboard-info-green">
                <span class="ob-dash-week-number">{{ weekModel.numberOfTasks }}</span>
            </div>
        </div>
    </div>

    <div class="col-12 col-lg-8">
        <div class="row g-3">
            <div class="col-12 col-md-6">
                <div class="ob-dash-stat-card">
                    <div class="ob-dash-stat-icon obrame-features-icon-bg">
                        <fa-icon [icon]="faUsers"></fa-icon>
                    </div>
                    <div class="ob-dash-stat-content">
                        <span class="ob-dash-stat-value">{{ dashboardModel.teamMemberships }}</span>
                        <span class="ob-dash-stat-label">Team</span>
                        <span class="ob-dash-stat-sub">Membership</span>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-6">
                <div class="ob-dash-stat-card">
                    <div class="ob-dash-stat-icon obrame-features-icon-bg">
                        <fa-icon [icon]="faClipboardCheck"></fa-icon>
                    </div>
                    <div class="ob-dash-stat-content">
                        <span class="ob-dash-stat-value">{{ dashboardModel.acceptedAssigments }}</span>
                        <span class="ob-dash-stat-label">Assignments</span>
                        <span class="ob-dash-stat-sub">Accepted</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>